<template>
	<div class="app-container">
		<router-view />
	</div>
</template>
<script setup lang="ts">
	// 20260324 新增根据当前访问地址 增加动态标题
	if (window.location.href.includes('demo.')) {
		document.title = '云联智办 - 云联办(体验)'
	}
</script>
<style lang="scss">
	@import "@/styles/handle.scss";
	
	html,
	body {
		padding: 0;
		margin: 0;
		// 20260105注释
		// position: relative;
	}
	
	// ::-webkit-scrollbar {
	// 	display: none;
	// }
	
	.recordNumberBlo {
		width: 100%;
		text-align: center;
	
		a {
			text-decoration: unset;
		}
	
		a:link {
			@include color('record_number_color');
		}
	
		a:visited {
			@include color('record_number_color');
		}
	
		a:hover {
			@include color('record_number_color');
		}
	
		a:active {
			@include color('record_number_color');
		}
	}
</style>